import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const problems = [{
    // IMAGEN: Billetera vacía o contando billetes
    image: 'https://images.unsplash.com/photo-1621980838194-e8aa6222b403?w=150&h=150&fit=crop&crop=faces',
    title: 'EL SUELDO SE EVAPORA',
    description: 'La inflación no perdona. Trabajas duro todo el mes, pero el dinero en bolívares desaparece en una semana. Sientes que tu calidad de vida y tu cuenta bancaria están estancadas.'
  }, {
    // IMAGEN: Persona mirando el teléfono frustrada
    image: 'https://images.unsplash.com/photo-1528699633788-424224dc89b5?w=150&h=150&fit=crop&crop=faces',
    title: 'SOLO TIENES TU CELULAR',
    description: 'Crees que para trabajar por internet necesitas una MacBook de $1,000 o equipos costosos. Te sientes limitado y frustrado porque actualmente solo cuentas con tu teléfono.'
  }, {
    // IMAGEN: Persona estresada / cansada
    image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=150&h=150&fit=crop&crop=faces',
    title: 'CERO EXPERIENCIA O INGLÉS',
    description: 'Ves a otros ganando bien por internet y sientes que llegaste tarde. No sabes programar, no hablas inglés fluido y los términos tecnológicos te abruman por completo.'
  }, {
    // IMAGEN: Reloj o calendario
    image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=150&h=150&fit=crop&crop=faces',
    title: 'AGOTAMIENTO Y ESTRÉS',
    description: 'Cumples horarios matadores haciendo tareas repetitivas o atendiendo clientes todo el día. Estás agotado mentalmente y sin tiempo libre para ti ni para tu familia.'
  }, {
    // IMAGEN: Pantalla con errores o cargando
    image: 'https://images.unsplash.com/photo-1534614971-6be99a7a3ffd?w=150&h=150&fit=crop&crop=faces',
    title: 'LA LUZ Y EL INTERNET FALLAN',
    description: 'Te frustra trabajar online porque el internet es lento o de repente se va la luz. Necesitas una herramienta que te permita generar el trabajo en segundos antes de quedarte offline.'
  }, {
    // IMAGEN: Persona pensando / preocupada
    image: 'https://images.unsplash.com/photo-1618018352910-72bdafdc40a6?w=150&h=150&fit=crop&crop=faces',
    title: 'CANSADO DE ESTAFAS',
    description: 'Ya intentaste hacer "plata fácil" con juegos, encuestas o aplicaciones dudosas que nunca pagan. Buscas aprender una habilidad real y segura que dependa 100% de ti.'
  }];
  return <section className="py-24 relative z-10 bg-[#050505]" data-id="element-244">
      <div className="container mx-auto px-4" data-id="element-245">
        {/* Encabezado */}
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-246">
          <motion.h2 initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black text-white mb-6 tracking-tight" data-id="element-247">
            ¿TE SIENTES <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500 drop-shadow-[0_0_15px_rgba(239,68,68,0.5)]" data-id="element-248">IDENTIFICADO?</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-gray-400 text-lg md:text-xl font-light" data-id="element-249">
            Si marcaste mentalmente al menos una de estas casillas, no es tu culpa. Pero el <strong className="text-white" data-id="element-250">Masterkit IA</strong> fue diseñado específicamente para sacarte de ahí.
          </motion.p>
          <div className="h-1 w-24 bg-red-500 mx-auto rounded-full shadow-[0_0_15px_rgba(239,68,68,0.5)] mt-8 animate-pulse" data-id="element-251" />
        </div>

        {/* Grid de Problemas */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-252">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-50px"
        }} transition={{
          delay: index * 0.1
        }} className="relative group p-8 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-red-500/40 hover:bg-white/[0.06] hover:shadow-[0_0_30px_rgba(239,68,68,0.1)] transition-all duration-300 flex flex-col items-center text-center overflow-hidden" data-id="element-253">
              {/* Brillo de fondo al hacer hover */}
              <div className="absolute inset-0 bg-gradient-to-b from-red-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-254" />

              {/* Imagen Circular con Brillo */}
              <div className="relative mb-6 z-10" data-id="element-255">
                <div className="w-24 h-24 rounded-full p-1 bg-gradient-to-br from-red-500/30 to-transparent border border-white/10 shadow-[0_0_20px_rgba(239,68,68,0.1)] group-hover:scale-110 transition-transform duration-500" data-id="element-256">
                   <img src={problem.image} alt={problem.title} className="w-full h-full rounded-full object-cover grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" data-id="element-257" />
                </div>
                {/* Icono de alerta flotante */}
                <div className="absolute -top-2 -right-2 bg-[#050505] rounded-full p-1.5 border border-red-500/50 shadow-[0_0_10px_rgba(239,68,68,0.3)]" data-id="element-258">
                   <svg className="w-4 h-4 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-259">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-260" />
                   </svg>
                </div>
              </div>

              <h3 className="text-xl font-bold text-white mb-4 group-hover:text-red-400 transition-colors z-10" data-id="element-261">
                {problem.title}
              </h3>
              
              <p className="text-gray-400 text-sm md:text-base leading-relaxed z-10" data-id="element-262">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}